import { type Slot } from "../queries/useCampaignAvailability";
import {
	formatMonthDay,
	formatTime,
	formatWeekday,
	prettyTz,
	ymd,
} from "./format";

type SuccessStepProps = {
	slot: Slot;
	timezone: string;
	advisorName: string;
	leadEmail: string;
};

export function SuccessStep({
	slot,
	timezone,
	advisorName,
	leadEmail,
}: SuccessStepProps) {
	const slotDateKey = ymd(slot.start, timezone);

	return (
		<div>
			<p className="font-semibold tracking-[0.16em] uppercase text-xs text-[#9c8230]">
				Step 03 — Confirmed
			</p>
			<h1 className='font-black tracking-tight leading-[0.95] font-["Gotham_Narrow","Helvetica_Neue",Arial,sans-serif] mt-3 text-5xl sm:text-6xl'>
				YOU'RE BOOKED.
			</h1>
			<p className="mt-4 max-w-lg text-base text-[#2c4239]">
				A calendar invite is on its way to{" "}
				<span className="font-semibold">{leadEmail}</span>. We look forward to
				speaking with you.
			</p>

			<dl className="mt-10 max-w-xl divide-y divide-[#1a2e26]/15 border-t border-b border-[#1a2e26]/15">
				<Row label="With" value={advisorName} />
				<Row
					label="When"
					value={`${formatWeekday(slotDateKey, timezone)}, ${formatMonthDay(slotDateKey, timezone)}`}
				/>
				<Row
					label="Time"
					value={`${formatTime(slot.start, timezone)} – ${formatTime(slot.end, timezone)}`}
				/>
				<Row label="Timezone" value={prettyTz(timezone)} />
			</dl>
		</div>
	);
}

function Row({ label, value }: { label: string; value: string }) {
	return (
		<div className="flex flex-col gap-0.5 py-4 sm:flex-row sm:items-baseline sm:gap-8">
			<dt className="font-semibold tracking-[0.16em] uppercase text-xs w-32 shrink-0 text-[#2c4239]">
				{label}
			</dt>
			<dd className="text-base">{value}</dd>
		</div>
	);
}
